export class HorseBetInfoModel {
    totalBetAmount: number;
    displayStrategyWP: string;
    betAmountWP: number;
    totalBetsWP: number;
    betAmountW: number;
    totalBetsW: number;
    betAmountP: number;
    totalBetsP: number;
    displayStrategyQQP: string;
    betAmountQQP: number;
    totalBetsQQP: number;
    betAmountQ: number;
    totalBetsQ: number;
    betAmountQP: number;
    totalBetsQP: number;


  constructor(totalBetAmount: number, displayStrategyWP: string, betAmountWP: number, totalBetsWP: number, betAmountW: number, totalBetsW: number, betAmountP: number, totalBetsP: number,
    displayStrategyQQP: string, betAmountQQP: number, totalBetsQQP: number, betAmountQ: number, totalBetsQ: number, betAmountQP: number, totalBetsQP: number) {
    this.totalBetAmount = totalBetAmount;
    this.displayStrategyWP = displayStrategyWP;
		this.betAmountWP = betAmountWP;
		this.totalBetsWP = totalBetsWP;
		this.betAmountW = betAmountW;
		this.totalBetsW = totalBetsW;
		this.betAmountP = betAmountP;
    this.totalBetsP = totalBetsP;
    this.displayStrategyQQP = displayStrategyQQP;
		this.betAmountQQP = betAmountQQP;
		this.totalBetsQQP = totalBetsQQP;
		this.betAmountQ = betAmountQ;
		this.totalBetsQ = totalBetsQ;
		this.betAmountQP = betAmountQP;
		this.totalBetsQP = totalBetsQP;
	}
}



// WEBPACK FOOTER //
// ./src/model/horse/HorseBetInfoModel.ts